<template>
    <div class="wrapperCard" @click.stop><!-- previene el cierre inesperado del form clickeando en cualquier area-->
      <div v-if="loading">
        <LoadingSpinner />
      </div>
      <div v-else class="p-3">
        <div class="mt-3" >
          <button
            class="btnActivity"
            :class="isPhoneCallSelected ? 'active' : ''"
            @click="changeEventId('1')"
            v-if="false"
          >
            <span class="icon-phone_in_talk"></span>
          </button>
          <button
            class="btnActivity"
            :class="isAppointmentSelected ? 'active' : ''"
            @click="changeEventId('2')"
            v-if="false"
          >
            <span class="icon-clock"></span>
          </button>
        </div>
        <form action class="formActivity mt-3">
          <div class="form-row">
            <div class="form-group col-12 text-left">
              <label for="inputEmail4">{{ $t('lang.label.day') }}</label>
              <date-picker
                :disabled="optionTask == '3' || optionTask == '6'"
                v-model="day"
                :config="configs.day"
                v-bind:placeholder="$t('lang.label.clickheretosetday')">
              </date-picker>
            </div>
            <div class="form-group col-12 text-left">
              <label for="inputPassword4">{{ $t('lang.label.hour') }}</label>
              <date-picker
                :disabled="optionTask == '3' || optionTask == '4' || optionTask == '6'"
                v-model="hour"
                :config="configs.hour"
                v-bind:placeholder="$t('lang.label.clickheretosethour')"
              ></date-picker>
            </div>
          </div>
          <div class="form-group text-left">
            <label for="exampleFormControlSelect1">Contacts</label>
            <!-- v-model="selectedBusinessContact.id" -->
            <select
            v-model="business_contact_id"
            :disabled="businessContactsFiltered.length <= 1"
            class="form-control"
            id="exampleFormControlSelect1"            
            >
              <option
                v-for="status in businessContactsFiltered"
                :key="status.id"
                :value="status.id"
              >
                {{ status.name }} ({{ status.email }})
              </option>
            </select>
          </div>
          <div class="form-group">
            <textarea
              class="form-control mt-3"
              v-bind:placeholder="$t('lang.label.comment')"
              id="exampleFormControlTextarea1"
              rows="3"
              v-model="remark"
              :disabled="optionTask == '3' || optionTask == '4' || optionTask == '6'"
            ></textarea>
          </div>
        </form>
        <div v-if="canSave" class="float-left pb-3">
          <button
            class="btn btn-primary themed-button ml-1"
            @click.once="createEvent"
          >{{ $t('lang.button.save') }}</button>
        </div>
        <div v-else class="float-left pb-3">
          <Tooltip :text="$t('lang.problem.lead_room')" :width="'auto'">
            <button
            class="btn btn-primary themed-button ml-1"
            :disabled="true"
            @click.once="createEvent"
            >{{ $t('lang.button.save') }}</button>
          </Tooltip>
        </div>
        <button
        class="btn btn-primary themed-button mx-2 float-left"
        @click.once="closeFormEvent"
      >Close</button>
      </div>
    </div>
</template>

<script>
import { linksService, opportunitiesService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components:{
    LoadingSpinner,
    Tooltip
  },
  data() {
    return {
      eventId: "1",
      day:  moment().format('DD-MM-YYYY'),
      hour: "2:00 PM",
      remark: "Call back",
      business_contact_id: 0,
      loading: false,
      configs: {
        day: {
          format: "DD-MM-YYYY",
          useCurrent: false,
          minDate: moment().add(1, 'days').startOf("day")
        },
        hour: {
          format: "LT",
          useCurrent: false,
          minDate: moment().set({ hour: 9, minute: 0, second: 0, millisecond: 0 })
        }
      }
    };
  },

  props: {
    linkId: String,
    currentTaskFound: Object,
    optionTask: Number,
    selectedBusinessContact: Object,
    businessContactsFiltered: Array
  },

  computed: {
    minDate() {
      return moment().add(1, 'days').startOf("day");
    },
    isPhoneCallSelected() {
      return this.eventId === "1";
    },

    isAppointmentSelected() {
      return this.eventId === "2";
    },

    canSave() {
      return this.remark != "" && this.day != null && this.hour != null && this.business_contact_id != null && this.business_contact_id != 0 && this.isContactInArray(this.business_contact_id);
    }
  },

  watch: {
    selectedBusinessContact(newVal) {
      this.business_contact_id = newVal.id;
    }
  },


  created(){
     this.eventId = 2;
     this.business_contact_id = this.selectedBusinessContact.id;
  },
  mounted(){
    if(this.currentTaskFound){

      switch (this.optionTask) {
        case 2:
          this.configs.hour = {
            ...this.configs.hour,
            minDate: moment().set({ hour: 9, minute: 0, second: 0, millisecond: 0 })
          }
          this.day = moment().add(1 , 'day').format('DD-MM-YYYY');
          this.hour = "9:00 AM";
          break;

        case 3:
        case 6:
          const { link_status_id, link_status_reason_id, tag_id } = this.currentTaskFound;
          if (tag_id == '371' || (link_status_id == '8' && link_status_reason_id == '35')) {
            //console.log('is... task... super positive o absent')
            this.day = moment().add(2 , 'day').format('DD-MM-YYYY');
//            this.hour = "4:00 PM";
            this.hour = moment().format('HH:mm');
            this.hour = "9:30 AM";
          } else {
            this.day = moment().add( 2 , 'day').format('DD-MM-YYYY');
            this.hour = moment().format('HH:mm');
            this.hour = "9:30 AM";
          }
          break;

        case 4:
          this.remark = "Send Reminder";
          this.day = moment().add(1, 'day').format('DD-MM-YYYY');
          this.hour = "8:00 AM";
          break;
      }
    }
  },

  methods: {
    ...mapActions("opportunities", {
      reloadOpportunity: "reloadOpportunity",
      getPriorityopportunity: "getPriority",
      resetPriorityopportunity: "resetPriority"
    }),

    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),

    changeEventId(activity) {
      this.eventId = activity;
    },

    closeFormEvent(){
      this.$emit('closeFormEvent');
    },

    async checkOpportunityToTask(opportunityId) {
      try {

        const res = await opportunitiesService.checkOpportunityToTask(opportunityId);
        const { result } = res;
        return (result == 'ok') ? true : false;

      } catch (error) {
        console.log(error)
        return false;
      }
    },

    async createEvent() {
      this.loading = true;
      const hasPermissionToThisOpportunity = await this.checkOpportunityToTask(this.linkId);

      if(hasPermissionToThisOpportunity) {
        const eventDate = this.createEventDate(this.day,this.formatTime(this.hour));

        linksService.createEvent(this.linkId, this.eventId, this.remark, eventDate, this.business_contact_id)
          .then(event => {
            //this.reloadOpportunity({ headerTab: "NOTHING" })
            this.$emit('closeFormEvent', true);
          });
      } else {
        this.$emit('getMoreTasks');
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: this.$t("lang.label.error_task"),
          showConfirmButton: true,
          confirmButtonText: this.$t("lang.button.ok"),
          allowOutsideClick: false

          }).then(() => {
            //console.log("")
        });
      }
    },

    createEventDate(day, hour) {
      var dayArray = day.split(/-|\s|:/);
      return `${dayArray[2]}-${dayArray[1]}-${dayArray[0]} ${hour}`;
    },

    formatTime(time) {
      // const m = moment(time, ["h:mm A", "H:mm", "HH:mm"], true);
      // return m.isValid() ? m.format("HH:mm:00") : time;

      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return `${sHours}:${sMinutes}:00`;
    },

    isContactInArray(id){
      return this.businessContactsFiltered.some(contact => contact.id === id);
    }
  }
};
</script>
